module.exports = __webpack_public_path__ + "static/media/credit-cards-zelle-venmo.57e76013.png";